import React from 'react';
import styled from '@emotion/styled';

const Frame = styled.div({
    backgroundColor: '#f5f5f5',
    borderRadius: '4px',
    height: '20px',
    boxShadow: 'inset 0 1px 2px rgba(0, 0, 0, .1)',
});

type BarProps = {
    ratio: number;
    speed?: number;
}

const Bar = styled.div<BarProps>(props => ({
    height: '100%',
    width: `${props.ratio * 100}%`,
    backgroundColor: '#5bc0de',
    boxShadow: 'inset 0 -1px 0 rgba(0, 0, 0, .15)',
    transition: props.speed === undefined ? undefined : `width ${props.speed}s`,
}));

export type ProgressBarProps = {
    className?: string;
    ratio: number;
    speed?: number;
}

export const ProgressBar = (props: ProgressBarProps) => {
    return (
        <Frame className={props.className}>
            <Bar ratio={props.ratio} speed={props.speed} />
        </Frame>
    );
};
